import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteElement, fetchData, handleAddItem } from "../../utils/data";
import i18n from "../../i18n";
const lang = i18n.language === "ar" ? "ar" : "en";
// Async Thunks
export const fetchFavorites = createAsyncThunk("get/favorite", async ({ id }: { id: string }) => {
    const data = await fetchData(`Favorite/getFavorites?UserID=${id}&lang=${lang}`, true);
    return data;
});

export const addFavorite = createAsyncThunk("post/Favorite", async (favData: any) => {
    await handleAddItem(favData, "Favorite/addFavorite", "POST");
    return favData;
});

export const deleteFavorite = createAsyncThunk("delete/Favorite", async (favData: any) => {
    await deleteElement(`Favorite/deleteFavorite`, favData);
    return favData;
});

// State Type
interface favoritestate {
    favorites: {
        stays: any[];
        halls: any[];
        trips: any[];
    };
    loading: boolean;
}

// Initial State
const initialState: favoritestate = {
    favorites: {
        stays: [],
        halls: [],
        trips: [],
    },
    loading: false,
};

// Slice
const favoriteslice = createSlice({
    name: "favoriteslice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch Favorites
            .addCase(fetchFavorites.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchFavorites.fulfilled, (state, action) => {
                state.loading = false;

                const payload = action.payload || {};

                state.favorites = {
                    stays: payload.stays || [],
                    halls: payload.halls || [],
                    trips: payload.trips || [],
                };
            })

            // Add Favorite
            .addCase(addFavorite.fulfilled, (state, action) => {
                const { type } = action.payload;

                if (type === "Place") {
                    const place = action.payload.place || action.payload;
                    const isHall = place.subCategory?.category?.title === "Halls";

                    if (isHall) {
                        state.favorites.halls.push({ ...action.payload });
                    } else {
                        state.favorites.stays.push({ ...action.payload });
                    }
                }

                if (type === "Trip") {
                    state.favorites.trips.push({ ...action.payload });
                }
            })
    },
});

export default favoriteslice.reducer;
